import styled, { css } from 'styled-components';

const styles = css`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  box-sizing: border-box;
  margin: 20px auto;
`;

export const Template = styled.div`
  max-width: 912px;
  margin: 20px auto;
  border: 1px solid #F0F4F8;
  display: flex;
  border-radius: 8px;
  flex-wrap: wrap;
`;

export const Title = styled.div`
  ${styles};
  padding: 0 20px;
`;

export const Summary = styled.div`
  ${styles};
  margin-top: 48px;
`;

export const InformationWrapper = styled.div`
  width: 600px;
  max-width: 100%;
  border-radius: 8px;
  display: flex;
  margin-bottom: 16px;
  border: 1px solid #F0F4F8;
  flex-wrap: wrap;
`;

export const Information = styled.div`
  box-sizing: border-box;
  min-width: 50%;
  max-width: 100%;
  width: calc((600px - 100%) * 600);
  display: flex;
  align-items: center;
  flex-direction: column;
  border: 1px solid #F0F4F8;
  height: 88px;
  padding: 16px 0;
`;

export const DateWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
  padding: 0 20px;
`;

export const Date = styled.div`
  width: calc(100% - 32px);

  @media(min-width: 480px) {
    width: 496px;
  }
`;

export const PaymentShops = styled.div`
  ${styles};
  padding: 0 20px;
`;

export const Separator = styled.hr`
  border: 1px solid #F0F4F8;
  width: 95%;
  margin-bottom: 39px;
`;

export const PaymentMethods = styled.div`
  ${styles};
`;

export const StepsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  @media(min-width: 480px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const Step = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;

  @media(min-width: 480px) {
    width: 50%;
  }
`;
